import r from "./SharedContentErrorNode-D66T6ULq.js";
import { resolveComponent as e, createBlock as n, openBlock as t } from "vue";
import { _ as a } from "./main-DQQ1cljm.js";
const d = {
  name: "EditableSharedContentErrorNode",
  components: {
    SharedComponentErrorNode: r
  }
};
function p(c, m, s, _, f, i) {
  const o = e("SharedComponentErrorNode");
  return t(), n(o);
}
const C = /* @__PURE__ */ a(d, [["render", p]]);
export {
  C as default
};
